export async function taskToExternal(task, data) {
  const doc = task ? await task.get() : {}
  data = doc?.docs?.[0]?.data() ?? data
  if (doc.exists || data) {
    const taskData = data || doc.data()
    if (!taskData.TaskType) taskData.TaskType = 'Input from Client' // In case there isn't a task type selected during a preview
    taskData.InternalName = taskData.Name // Set internal name of task to the name
    taskData.Name = taskData.ExternalName || taskData.Name // Set Name of task to the external name
    delete taskData.ExternalName
    return { ...taskData, ...{ FirstClientVisitTime: false } }
  }
}